"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var flight_class_1 = require("iris/dist/helpers/ibe/flight_class");
var master_data_1 = require("./master_data");
// which request has fired last?
function lastFetchRequestKey(state) {
    return state.loading;
}
exports.lastFetchRequestKey = lastFetchRequestKey;
// which flight has been selected
function flightSelection(state) {
    var selectedFlight = lodash_1.find(state.flights, function (flight) {
        return flight.id === state.flightSelection.selected;
    });
    return selectedFlight;
}
exports.flightSelection = flightSelection;
// which code has been selected
function flightSelectionCode(state) {
    return state.flightSelection.selected;
}
exports.flightSelectionCode = flightSelectionCode;
// which airport code has been selected
function selectedAirportCode(state) {
    return state.selectedFilters.airport ? state.selectedFilters.airport.locCd : null;
}
exports.selectedAirportCode = selectedAirportCode;
// which airport name has been selected
function selectedAirportName(state) {
    return state.selectedFilters.airport ? state.selectedFilters.airport.locName : null;
}
exports.selectedAirportName = selectedAirportName;
function airlines() {
    return Array.from(master_data_1.default.flexFlightAirlines);
}
exports.airlines = airlines;
function selectedAirlineCodes(state) {
    return Array.from(state.selectedFilters.airlineCodes);
}
exports.selectedAirlineCodes = selectedAirlineCodes;
function mayAddAirlines(state) {
    return state.selectedFilters.airlineCodes.length < master_data_1.default.maxSelectableAirlinesCount;
}
exports.mayAddAirlines = mayAddAirlines;
function maxSelectableAirlinesCount() {
    return master_data_1.default.maxSelectableAirlinesCount;
}
exports.maxSelectableAirlinesCount = maxSelectableAirlinesCount;
function nonstop(state) {
    return state.selectedFilters.nonstop;
}
exports.nonstop = nonstop;
// which class code has been selected
function selectedClassCode(state) {
    return state.selectedFilters.flightClass ? state.selectedFilters.flightClass : null;
}
exports.selectedClassCode = selectedClassCode;
// which direction code has been selected
function selectedDirectionCode(state) {
    return state.selectedFilters.flightDirection ? state.selectedFilters.flightDirection : null;
}
exports.selectedDirectionCode = selectedDirectionCode;
// return the ready-made list usable for select-fields with {name, value, price}
function flexFlights(state) {
    return state.flights;
}
exports.flexFlights = flexFlights;
// returns the airport list for flex flights
function airports(state) {
    if (state.airports) {
        return state.airports.list;
    }
    return [];
}
exports.airports = airports;
function availableAirports(state) {
    return airports(state).map(function (airport) { return ({
        code: airport.locCd,
        name: airport.locName,
    }); });
}
exports.availableAirports = availableAirports;
function cachedGatewaysFor(state) {
    return function (priceModel) { return state.cachedGateways[priceModel]; };
}
exports.cachedGatewaysFor = cachedGatewaysFor;
// which AirConnection is selected?
function selectedConnection(state) {
    var selectedFlightId = state.flightSelection.selected;
    return state.flights.find(function (flight) { return flight.id === selectedFlightId; });
}
exports.selectedConnection = selectedConnection;
// what is the selected flight class?
function selectedFlightClass(state) {
    if (!!state.selectedFilters.flightClass) {
        return flight_class_1.flightClassName(state.selectedFilters.flightClass);
    }
    else {
        return '';
    }
}
exports.selectedFlightClass = selectedFlightClass;
// is the chosen selection valid?
function valid(state) {
    if (totalPrice(state) === 0) {
        return false;
    }
    return true;
}
exports.valid = valid;
// gather all data required for a booking request
function transportOptionsForBooking(state) {
    var conn = selectedConnection(state);
    if (!!conn) {
        var transFlexFlights = [
            {
                category: conn.class,
                code: conn.id,
                direction: conn.direction,
                type: 'AIR',
                price: conn.price,
            }
        ];
        return transFlexFlights;
    }
    else {
        return [];
    }
}
exports.transportOptionsForBooking = transportOptionsForBooking;
// calculate the total price of the chosen flights
function totalPrice(state) {
    var differ = currentPriceDiffer(state);
    if (!!differ) {
        return differ;
    }
    return selectedConnPrice(state);
}
exports.totalPrice = totalPrice;
function steps(state) {
    return state.steps;
}
exports.steps = steps;
function availableFlightClasses(state) {
    var airport = state.selectedFilters.airport;
    if (!airport)
        return [];
    var flightClassList = [];
    airport.flightClassMap.forEach(function (_value, key, _map) {
        return flightClassList.push({
            code: key,
            name: flight_class_1.flightClassName(key),
        });
    });
    var sortedFlightClasses = lodash_1.sortBy(flightClassList, ['code']);
    return sortedFlightClasses.reverse();
}
function availableFlightDirections(state) {
    var airport = state.selectedFilters.airport;
    if (!airport)
        return [];
    var directionList = [];
    airport.directionMap.forEach(function (_value, key, _map) {
        return directionList.push({
            code: key,
            name: displayDirection(key),
        });
    });
    return directionList;
}
function displayDirection(direction) {
    switch (direction) {
        case 'RT': {
            return 'Hin- und Rückflug';
        }
        case 'R': {
            return 'Rückflug';
        }
        case 'O': {
            return 'Hinflug';
        }
        default: return 'none';
    }
}
function rnfDeparture(state) {
    return state.rnfDeparture;
}
exports.rnfDeparture = rnfDeparture;
function rnfArrival(state) {
    return state.rnfArrival;
}
exports.rnfArrival = rnfArrival;
function rnfCategory(state) {
    return state.rnfCategory;
}
exports.rnfCategory = rnfCategory;
function rnfTotalPrice(state) {
    return state.rnfTotalPrice;
}
exports.rnfTotalPrice = rnfTotalPrice;
function rnfTransportations(state) {
    return state.rnfTransportations;
}
exports.rnfTransportations = rnfTransportations;
function rnfDirection(state) {
    if (rnfDeparture(state) && !rnfArrival(state))
        return 'O';
    if (!rnfDeparture(state) && rnfArrival(state))
        return 'R';
    return 'RT';
}
exports.rnfDirection = rnfDirection;
function validForLoadRnf(state) {
    return validForRnf(state) &&
        (rnfDeparture(state) || rnfArrival(state));
}
exports.validForLoadRnf = validForLoadRnf;
function validForRnf(state) {
    if (selectedConnection(state) === null) {
        return false;
    }
    return ((validDepartureRnf(state) && validArrivalRnf(state)) ||
        (validDepartureRnf(state) && selectedDirectionCode(state) === 'O') ||
        (validArrivalRnf(state) && selectedDirectionCode(state) === 'R'));
}
exports.validForRnf = validForRnf;
function validDepartureRnf(state) {
    var selectedFlight = flightSelection(state);
    if (selectedFlight) {
        var outConnections = lodash_1.filter(selectedFlight.connections, function (conn) {
            return conn.direction === "O";
        });
        if (outConnections.length) {
            return outConnections[0].departure.airport.isoCountry === 'DE';
        }
    }
    return false;
}
exports.validDepartureRnf = validDepartureRnf;
function validArrivalRnf(state) {
    var selectedFlight = flightSelection(state);
    if (selectedFlight) {
        var retConnections = lodash_1.filter(selectedFlight.connections, function (conn) {
            return conn.direction === "R";
        });
        if (retConnections.length) {
            return lodash_1.last(retConnections).arrival.airport.isoCountry === 'DE';
        }
    }
    return false;
}
exports.validArrivalRnf = validArrivalRnf;
function selectedOutAirportName(state) {
    var selectedFlight = flightSelection(state);
    if (outFlights(selectedFlight)) {
        return outFlights(selectedFlight)[0].depAirport;
    }
    return "";
}
exports.selectedOutAirportName = selectedOutAirportName;
function selectedRetAirportName(state) {
    var selectedFlight = flightSelection(state);
    if (retFlights(selectedFlight)) {
        return lodash_1.last(retFlights(selectedFlight)).arrAirport;
    }
    return "";
}
exports.selectedRetAirportName = selectedRetAirportName;
function selectedOutFlights(state) {
    return outFlights(flightSelection(state));
}
exports.selectedOutFlights = selectedOutFlights;
function selectedRetFlights(state) {
    return retFlights(flightSelection(state));
}
exports.selectedRetFlights = selectedRetFlights;
function fetchTime(state) {
    return state.fetchTime;
}
// returns the priceDiffer from state
function currentPriceDiffer(state) {
    return state.priceDiffer;
}
exports.currentPriceDiffer = currentPriceDiffer;
// returns the price of the selected connection - call to compare to priceDiffer !
function selectedConnPrice(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.price;
    }
    return 0;
}
exports.selectedConnPrice = selectedConnPrice;
// export everything compliant to the vuex specification for getters
exports.default = {
    airlines: airlines,
    airports: airports,
    availableAirports: availableAirports,
    availableFlightClasses: availableFlightClasses,
    availableFlightDirections: availableFlightDirections,
    cachedGatewaysFor: cachedGatewaysFor,
    currentPriceDiffer: currentPriceDiffer,
    flexFlights: flexFlights,
    flightSelection: flightSelection,
    flightSelectionCode: flightSelectionCode,
    lastFetchRequestKey: lastFetchRequestKey,
    maxSelectableAirlinesCount: maxSelectableAirlinesCount,
    mayAddAirlines: mayAddAirlines,
    nonstop: nonstop,
    rnfArrival: rnfArrival,
    rnfCategory: rnfCategory,
    rnfDeparture: rnfDeparture,
    rnfDirection: rnfDirection,
    rnfTotalPrice: rnfTotalPrice,
    rnfTransportations: rnfTransportations,
    selectedAirlineCodes: selectedAirlineCodes,
    selectedAirportCode: selectedAirportCode,
    selectedAirportName: selectedAirportName,
    selectedClassCode: selectedClassCode,
    selectedConnection: selectedConnection,
    selectedConnPrice: selectedConnPrice,
    selectedDirectionCode: selectedDirectionCode,
    selectedFlightClass: selectedFlightClass,
    selectedOutAirportName: selectedOutAirportName,
    selectedOutFlights: selectedOutFlights,
    selectedRetAirportName: selectedRetAirportName,
    selectedRetFlights: selectedRetFlights,
    steps: steps,
    totalPrice: totalPrice,
    transportOptionsForBooking: transportOptionsForBooking,
    valid: valid,
    validArrivalRnf: validArrivalRnf,
    validDepartureRnf: validDepartureRnf,
    validForLoadRnf: validForLoadRnf,
    validForRnf: validForRnf,
    fetchTime: fetchTime
};
function outFlights(flightSelection) {
    var outConnections = lodash_1.filter(flightSelection.connections, function (conn) {
        return conn.direction === 'O';
    });
    return outConnections.length ? airConn(outConnections, flightSelection.className) : false;
}
function retFlights(flightSelection) {
    var retConnections = lodash_1.filter(flightSelection.connections, function (conn) {
        return conn.direction === 'R';
    });
    return retConnections.length ? airConn(retConnections, flightSelection.className) : false;
}
function airConn(airConnections, className) {
    var airConns = [];
    lodash_1.forEach(airConnections, function (conn) {
        var travelDepDate = conn.departure.time.split(" ")[0];
        var travelArrDate = conn.arrival.time.split(" ")[0];
        var depTime = conn.departure.time.split(" ")[1].substring(0, 5);
        var arrTime = conn.arrival.time.split(" ")[1].substring(0, 5);
        var flightConnection = {
            depAirport: conn.departure.airport.name,
            depAirportCode: conn.departure.airport.id,
            depTime: depTime,
            travelDepDate: travelDepDate,
            arrAirport: conn.arrival.airport.name,
            arrAirportCode: conn.arrival.airport.id,
            arrTime: arrTime,
            travelArrDate: travelArrDate,
            flightNumber: conn.airline.id + ' ' + conn.flightNumber,
            className: className
        };
        airConns.push(flightConnection);
    });
    return airConns;
}
//# sourceMappingURL=getters.js.map